import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_at5l4qlr: FaireBrandEntity = {
  token: "b_at5l4qlr",
  type: "brand",
  name: "Ancient Nutrition",
  avatarUrl:
    "https://cdn.faire.com/fastly/8eaf672b00ae287585cbb5ce5e1dbec8bdead2403176d1c96a31215c99f9344a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/51174d362e9dfb7e5df290ab1e28d246419bf078853ed6bb4b39a5edaa65dc8e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8eaf672b00ae287585cbb5ce5e1dbec8bdead2403176d1c96a31215c99f9344a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/51174d362e9dfb7e5df290ab1e28d246419bf078853ed6bb4b39a5edaa65dc8e.jpeg",
  location: "Franklin, TN, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 20,
  isInsider: true,
  description:
    "We’re going to save the world with superfoods.\nWe believe history's most powerful superfoods can transform the health of every individual on the planet. That’s why we create the highest quality supplements possible – formulas informed by ancient wisdom and modern science. And that’s why we’re working towards a new standard for how those ingredients are grown – one that gives back to the soil, instead of just taking from it.\n\nProper nutrition isn’t just about eating the right foods. It’s about ingredients your body can truly use. We leverage ancient wisdom – including techniques like fermentation and herb combining – and the latest nutrition science to create formulas that are easy for your body to absorb. Which means you’ll see and feel a meaningful impact from each of our products.\n\nJordan Rubin and Dr. Josh Axe share a deep belief in the power of superfoods. After navigating their own health journeys (or experiencing the journeys of people closest to them), Jordan and Josh committed themselves to creating the high-quality supplements they couldn’t find on the market: products that unite nature and science to help people live their healthiest lives in mind, body and spirit. That’s how Ancient Nutrition was born.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:19.380Z",
    importedBy: "entity-db-cli",
  },
};
